import Core from '../plugin-core-system/core.class.js';

export default class CsScrollToTop extends Core {

  /**
   * on click -> scroll to top of the page
   */
  scrollToTopOnClick() {
    this.el.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  init() {
    this.scrollToTopOnClick();
  }
}
